var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAngleDownAlert = function SvgAngleDownAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0617 10.5265L12.0012 12.5871L7.7072 8.29306C7.51956 8.10555 7.26512 8.00026 6.99985 8.00036C6.8685 8.0004 6.73845 8.02632 6.61712 8.07663C6.49578 8.12693 6.38555 8.20065 6.2927 8.29356C6.19986 8.38647 6.12622 8.49676 6.076 8.61812C6.02578 8.73949 5.99995 8.86956 6 9.00091C6.00009 9.26618 6.10556 9.52055 6.2932 9.70806L11.2942 14.7081C11.4817 14.8955 11.736 15.0008 12.0012 15.0008C12.2664 15.0008 12.5207 14.8955 12.7082 14.7081L15.8234 11.5929C15.1735 11.3398 14.5787 10.9767 14.0617 10.5265Z",
    fill: "#3A3A47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4811 9.10721L16.2942 8.29406C16.3865 8.19855 16.4968 8.12237 16.6188 8.06996C16.7408 8.01755 16.872 7.98996 17.0048 7.98881C17.1376 7.98765 17.2693 8.01295 17.3922 8.06324C17.5151 8.11352 17.6267 8.18777 17.7206 8.28166C17.8145 8.37556 17.8887 8.48721 17.939 8.6101C17.9893 8.733 18.0146 8.86468 18.0135 8.99746C18.0123 9.13024 17.9847 9.26146 17.9323 9.38346C17.8799 9.50547 17.8037 9.61581 17.7082 9.70806L17.4533 9.96292C16.7119 9.86155 16.0351 9.55699 15.4811 9.10721Z",
    fill: "#3A3A47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6C22 8.20914 20.2091 10 18 10C15.7909 10 14 8.20914 14 6C14 3.79086 15.7909 2 18 2C20.2091 2 22 3.79086 22 6Z",
    fill: "#D01E29"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAngleDownAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/angle_down_alert.ee948fb2.svg";
export { ForwardRef as ReactComponent };